import React from 'react';
import {Constants} from "./Constants";
import {useRenderableDataStore} from "./hooks/useRenderableDataStore";

interface DelayedSearchBarProps {
    value?: string;
    performSearch: Function;
    placeholder?: string;
}


let delayedSearchTimeout: number | undefined = undefined;

export let DelayedSearchBar = function (props: DelayedSearchBarProps) {
    const dataStore = useRenderableDataStore({
        searchText: props.value || '',
        prevValue: props.value || ''
    })

    if (props.value !== dataStore.data().prevValue) {
        dataStore.updateAndRender({
            searchText: props.value || '',
            prevValue: props.value
        })
    }

    function clearDelayedSearchTimeout() {
        window.clearTimeout(delayedSearchTimeout);
        delayedSearchTimeout = undefined;
    }

    function handleSearchTextChange(event: React.ChangeEvent<HTMLInputElement>) {
        clearDelayedSearchTimeout();
        let updatedSearchText = event.target.value;

        dataStore.updateAndRender({searchText: updatedSearchText});

        clearDelayedSearchTimeout();
        delayedSearchTimeout = window.setTimeout(function () {
            props.performSearch(updatedSearchText);
        }, Constants.searchDelayMs);
    }

    return (
        <div className="search-bar-outer-container">
            <div className="search-bar-container">
                <div className="search-bar-field-container">
                    <input
                        className="search-bar-field"
                        value={dataStore.data().searchText}
                        onChange={handleSearchTextChange}
                        placeholder={props.placeholder}
                    />
                </div>
                <div className="search-bar-icon-container">
                    <img
                        className="search-bar-icon"
                        src={
                            dataStore.data().searchText !== props.value ?
                                Constants.loadingIndicatorSrc :
                                "/static/images/search-green.svg"
                        }
                    />
                </div>
            </div>
        </div>
    );
};
